<template>
  <div class="popup-right-click">
    <!-- Open -->
    <div
      v-if="useOpen"
      class="menu-list"
      @click="$emit('open')"
    >
      <img
        src="@/assets/icon/foldering/open.svg"
        alt="open-icon"
      >
      <span>Open</span>
    </div>
    <!-- Open new tab -->
    <div
      v-if="useOpen"
      class="menu-list"
      @click="$emit('open-new-tab')"
    >
      <img
        src="@/assets/icon/foldering/open.svg"
        alt="open-tab-icon"
      >
      <span>Open in New Tab</span>
    </div>
    <!-- Move to -->
    <div
      v-if="useMove"
      class="menu-list"
      @click="$emit('move')"
    >
      <img
        src="@/assets/icon/foldering/move.svg"
        alt="open-icon">
      <span>Move to</span>
    </div>
    <!-- Download -->
    <div
      v-if="useDownload"
      class="menu-list"
      @click="$emit('download')"
    >
      <img
        src="@/assets/icon/foldering/download.svg"
        alt="open-icon">
      <span>Download</span>
    </div>
    <!-- Rename -->
    <div
      v-if="useRename"
      class="menu-list"
      @click="$emit('rename')"
    >
      <img
        src="@/assets/icon/foldering/rename.svg"
        alt="open-icon">
      <span>Rename</span>
    </div>
    <!-- Delete -->
    <div
      v-if="useDelete"
      class="menu-list"
      @click="$emit('delete')"
    >
      <img
        src="@/assets/icon/foldering/delete.svg"
        alt="open-icon">
      <span>Delete</span>
    </div>
    <!-- Detail -->
    <div
      v-if="useDetail"
      class="menu-list"
      @click="$emit('detail')"
    >
      <img
        src="@/assets/icon/foldering/detail.svg"
        alt="open-icon">
      <span>Detail</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    useOpen: {
      type: Boolean,
      default: true,
    },
    useMove: {
      type: Boolean,
      default: true,
    },
    useDownload: {
      type: Boolean,
      default: true,
    },
    useRename: {
      type: Boolean,
      default: true,
    },
    useDelete: {
      type: Boolean,
      default: true,
    },
    useDetail: {
      type: Boolean,
      default: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/popup/jPopupRightClick.vue